import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "t-search-popup__other-container" }
const _hoisted_2 = {
  key: 0,
  class: "t-search-popup__categories-container"
}
const _hoisted_3 = { class: "t-search-popup__categories-container__inner" }
const _hoisted_4 = { class: "t-search-popup__categories-header" }
const _hoisted_5 = { class: "t-search-popup__categories" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "t-search-popup__content-container"
}
const _hoisted_9 = { class: "t-search-popup__content-container__inner" }
const _hoisted_10 = { class: "t-search-popup__contents-header" }
const _hoisted_11 = { class: "t-search-popup__contents" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "t-search-popup__products-container"
}
const _hoisted_15 = { class: "t-search-popup__products-container__inner" }
const _hoisted_16 = { class: "t-search-popup__products-header" }
const _hoisted_17 = { class: "t-search-popup__products" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "t-search-popup__product__name" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "t-search-popup__product__variants" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "t-search-popup__product__artno" }
const _hoisted_25 = {
  key: 1,
  class: "t-search-popup__product__price t-search-popup__product__price--mobile"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 4,
  class: "t-search-popup__product__price"
}
const _hoisted_29 = {
  key: 0,
  class: "t-search-popup__product__price"
}
const _hoisted_30 = {
  key: 1,
  class: "t-search-popup__product__price t-search-popup__product__price--discount"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = ["href"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: "t-search-popup__button-container"
}
const _hoisted_35 = ["href"]

import TressProductTileTag from "@/components/TressProductTileTag.vue";
import dictionary from "@/i18n/dictionary.json";
import { StockStatus } from "@/enums/StockStatus";
import { VariantSelectorAsNumber } from "@/models/ProductList";
import { useI18n } from "vue-i18n";
import { CustomerType } from "@/enums/CustomerType";
import { PropType, onMounted, ref, watch } from "vue";
import { useBreakpoints } from "@/code/useBreakpoints";
import { QuickSearchViewModel } from "@/models/QuickSearchViewModel";
import { QuickSearchProductViewModel } from "@/models/QuickSearchProductViewModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSearchPopup',
  props: {
  searchResults: {
    type: Object as PropType<QuickSearchViewModel>,
    required: true,
  },
  isPopupOpen: {
    type: Boolean,
    required: true,
  },
  searchPageUrl: {
    type: String,
    required: true,
  },
  searchTerm: {
    type: String,
    required: true,
  },
  blueSiteLogotype: {
    type: String,
    required: false,
  },
},
  emits: {
  close: () => true,
},
  setup(__props, { emit }) {

const props = __props;

const $t = useI18n().t;


const el = ref<HTMLElement>();
const { isLg } = useBreakpoints();
const searchPageUrl = ref<string>(props.searchPageUrl);
const showAsB2b = window.customerType !== CustomerType.Private;
let closeEventController: AbortController | null;

const getVariantSelectorPrefix = (product: QuickSearchProductViewModel) => {
  if (product.variantSelector == VariantSelectorAsNumber.Variant) {
    return $t(dictionary.producttile.variants);
  } else if (product.variantSelector == VariantSelectorAsNumber.Color) {
    return $t(dictionary.producttile.colors);
  } else if (product.variantSelector == VariantSelectorAsNumber.Size) {
    return $t(dictionary.producttile.variants);
  } else if (product.variantSelector == VariantSelectorAsNumber.Hardness) {
    return $t(dictionary.producttile.hardnesses);
  }
};

const tryClose = (ev: MouseEvent) => {
  if (!(ev.target as HTMLElement).closest(".t-search-popup, .search-input")) {
    removeCloseEventListener();
    emit("close");
  }
};

const addCloseEventListener = () => {
  const controller = new AbortController();
  document.addEventListener("click", tryClose, { signal: controller.signal });
};

const removeCloseEventListener = () => {
  closeEventController?.abort();
};

const setOverflow = (hidden: boolean) => {
  document.documentElement.style.overflow = hidden ? "hidden" : "auto";
};

watch(
  () => props.searchTerm,
  (currVal: string) => {
    searchPageUrl.value = `${props.searchPageUrl}?term=${currVal}`;
  }
);

watch(
  () => props.isPopupOpen,
  (currVal) => {
    if (currVal) {
      addCloseEventListener();
      setOverflow(!isLg.value);
    } else {
      removeCloseEventListener();
      setOverflow(false);
    }
    _calcBottom();
  }
);

watch(isLg, (currVal) => {
  setOverflow(props.isPopupOpen ? !currVal : false);
  _calcBottom();
});

const _calcBottom = () => {
  if (el.value) {
    if (el.value.clientHeight + 138 > window.innerHeight) {
      el.value.style.bottom = "0";
    } else {
      el.value.style.bottom = "auto";
    }
  }
};

onMounted(() => {
  _calcBottom();
});

return (_ctx: any,_cache: any) => {
  const _component_tress_product_tile_default_image = _resolveComponent("tress-product-tile-default-image")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!

  return (__props.searchResults)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "el",
        ref: el,
        class: "t-search-popup"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.searchResults.categories && __props.searchResults.categories.items)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_unref($t)(_unref(dictionary).common.categories)), 1),
                  _createElementVNode("ul", _hoisted_5, [
                    (__props.searchResults.categories.items.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.searchResults.categories.items, (category) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: category.name,
                            class: "t-search-popup__category"
                          }, [
                            _createElementVNode("a", {
                              href: category.url
                            }, _toDisplayString(category.name), 9, _hoisted_6)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref($t)(_unref(dictionary).search.noProductsFound)), 1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.searchResults.pages && __props.searchResults.pages.items)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref($t)(_unref(dictionary).common.inspiration)), 1),
                  _createElementVNode("ul", _hoisted_11, [
                    (__props.searchResults.pages.items.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.searchResults.pages.items, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page.name,
                            class: "t-search-popup__content"
                          }, [
                            _createElementVNode("a", {
                              href: page.url
                            }, _toDisplayString(page.name), 9, _hoisted_12)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref($t)(_unref(dictionary).search.noProductsFound)), 1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.searchResults.pages && __props.searchResults.pages.items)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref($t)(_unref(dictionary).common.products)), 1),
                _createElementVNode("ul", _hoisted_17, [
                  (__props.searchResults.products.items.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.searchResults.products.items, (product) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: product.partNo
                        }, [
                          _createElementVNode("a", {
                            class: _normalizeClass([{
                  't-search-popup__product--not-in-stock': !showAsB2b && product.stockStatus === _unref(StockStatus).OutOfStock,
                }, "t-search-popup__product"]),
                            href: product.url
                          }, [
                            (product.imageUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.imageUrl,
                                  class: "t-search-popup__product__image"
                                }, null, 8, _hoisted_19))
                              : (_openBlock(), _createBlock(_component_tress_product_tile_default_image, {
                                  key: 1,
                                  class: "t-search-popup__product__image"
                                })),
                            _createElementVNode("p", _hoisted_20, [
                              _createTextVNode(_toDisplayString(product.name) + " ", 1),
                              _hoisted_21,
                              (product.numberOfVariants > 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", _hoisted_22, "+" + _toDisplayString(product.numberOfVariants) + " " + _toDisplayString(getVariantSelectorPrefix(product)), 1),
                                    _hoisted_23
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(product.partNo), 1),
                              (product.callForPrice)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref($t)(_unref(dictionary).product.callforprice)), 1))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: _normalizeClass([{
                        't-search-popup__product__price--discount-mobile': product.discountPercent,
                      }, "t-search-popup__product__price t-search-popup__product__price--mobile"])
                                  }, [
                                    _createTextVNode(_toDisplayString(product.price) + " ", 1),
                                    (product.discountPercent)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(product.originalPrice), 1))
                                      : _createCommentVNode("", true)
                                  ], 2))
                            ]),
                            (product.isExternal)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 2,
                                  src: __props.blueSiteLogotype,
                                  class: "t-search-popup__product__logotype"
                                }, null, 8, _hoisted_27))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  (
                      product.new && (!product.agreementPrice || !product.discountPercent || !product.quantityBreaks)
                    )
                                    ? (_openBlock(), _createBlock(TressProductTileTag, {
                                        key: 0,
                                        class: "t-search-popup__product__tag product-tile-tag--alternative product-tile-tag--new"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).common.new)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (product.discountPercent && !product.agreementPrice)
                                    ? (_openBlock(), _createBlock(TressProductTileTag, {
                                        key: 1,
                                        class: "t-search-popup__product__tag product-tile-tag--alternative"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(product.discountPercent), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (product.agreementPrice)
                                    ? (_openBlock(), _createBlock(TressProductTileTag, {
                                        key: 2,
                                        class: "t-search-popup__product__tag product-tile-tag--agreement-price"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).common.agreementPrice)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (product.quantityBreaks && (!product.agreementPrice || !product.discountPercent))
                                    ? (_openBlock(), _createBlock(TressProductTileTag, {
                                        key: 3,
                                        class: "t-search-popup__product__tag"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).common.massDiscount)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ], 64)),
                            (product.callForPrice)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_unref($t)(_unref(dictionary).product.callforprice)), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  (!product.discountPercent)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(product.price), 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_30, [
                                        _createTextVNode(_toDisplayString(product.originalPrice) + " ", 1),
                                        _hoisted_31,
                                        _createElementVNode("span", null, _toDisplayString(product.price), 1)
                                      ]))
                                ], 64)),
                            _createElementVNode("a", {
                              href: product.url,
                              class: _normalizeClass(["t-search-popup__product__link", { 't-search-popup__product__link--blue': product.isExternal }])
                            }, [
                              _createVNode(_component_icon_chevron_right)
                            ], 10, _hoisted_32)
                          ], 10, _hoisted_18)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_unref($t)(_unref(dictionary).search.noProductsFound)), 1))
                ]),
                (__props.searchResults.products.items.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("a", {
                        class: "t-search-popup__button",
                        href: searchPageUrl.value
                      }, _toDisplayString(_unref($t)(_unref(dictionary).search.seeAllProducts)) + " (" + _toDisplayString(__props.searchResults.products.count) + ")", 9, _hoisted_35)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}
}

})